import styled from 'styled-components';

interface ButtonsActiveIndicatorBoxProps {
  activeIndicatorWidth: number;
  activeIndicatorPosition: number;
}

export const ButtonsActiveIndicatorDefaultBox = styled.div<ButtonsActiveIndicatorBoxProps>`
  margin: -2.5em 0 0 0;
  height: 4em;
  background: url("${props => props.theme.images.liveArena.activeIndicatorBg.toString()}") center center / 100% 100% no-repeat;
  transition: width 0.25s ease, transform 0.25s ease;
  width: ${props => props.activeIndicatorWidth}px;
  transform: translateX(${props => props.activeIndicatorPosition}px)
`;